<div class="fixed-top custombg" style=" z-index: 100;">
    <div class="d-flex flex-column">
        <app-header #header></app-header>
        <app-breadcrumb></app-breadcrumb>
    </div>
</div>

<div class="main-body mt-5">   
    <div class="example-container d-flex flex-column w-100">         
      <div class="table-title w-100">
          <span>Settings</span>
      </div> 

      <div class="data-filter-container w-100">
        <div class="row w-100">
            <div class="col-2">Select Project</div>
            <div class="col-4">
                <select class="form-control" [(ngModel)]="selectedProjectId">
                    <option selected value=-1>-- Select Project --</option>
                    <option *ngFor="let project of projectList" [value]="project.projectId">{{project.projectName}}</option>
                </select>
            </div>
        </div>
      </div>  
      <div *ngIf="selectedProjectId > 0" class="body-container border-top-1-gray  w-100">
        <div class="w-100 mb-4">
            <div class="row w-100 frequency">
                <div class="col-2">Select Audit Frequency</div>
                <div class="col-2">
                    <select class="form-control" [(ngModel)]="selectedFrequencyId">
                        <option selected value=-1>-- Select Frequency --</option>
                        <option *ngFor="let freq of auditFrequencyList" [value]="freq.id">{{freq.description}}</option>
                    </select>
                </div>
                <div class="col-6" *ngIf="selectedFrequencyId == 4">
                 <span class="col-3">Comment: </span>
                 <input type="text" class="form-control col-9" placeholder="Enter comment - why frequency is not applicable" />
                </div>
            </div> 
            
        </div> 

        <div class="w-100">
            <div class="w-100">Select Audit Area(s)</div>
            <div class="row w-100">            
                <div class="col-4 col-offset-2 audit-area" *ngFor="let item of auditCategoryList">
                    <p><mat-checkbox [value]="item.id">{{item.description}}</mat-checkbox></p>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="selectedProjectId > 0" class="button_section w-100 text-right">
        <button class="btn btn-cancel"><span>Cancel</span></button>
        <button class="btn btn-submit">Submit</button>
    </div>

    </div> 
</div>